import { createAsyncThunk } from "@reduxjs/toolkit";
import { RootState } from "../../../app/store";
import UserActionStatusAPI, {
    UserActionsStatusResponse,
    ReportReviewPayload
} from "../../../api/UserActionsStatus";

export const fetchUserActionsStatusThunk = createAsyncThunk<
    UserActionsStatusResponse,
    { case_id: string },
    { rejectValue: string }
>(
    'reports/fetchUserActionsStatus',
    async ({ case_id }, { rejectWithValue }) => {
        try {
            return await UserActionStatusAPI.get_user_actions_status({ case_id });
        } catch (error: any) {
            return rejectWithValue(error.message || 'Failed to fetch user actions status');
        }
    }
);

export const updateMultipleIRReviewStatusesThunk = createAsyncThunk<
    { reviewers: ReportReviewPayload[] },
    { case_id: string; reviewers: ReportReviewPayload[] },
    { state: RootState; rejectValue: string }
>(
    "reports/updateMultipleIRReviewStatuses",
    async ({ case_id, reviewers }, { rejectWithValue }) => {
        try {
            if (!reviewers.length) {
                return { reviewers: [] };
            }

            await Promise.all(
                reviewers.map(({ action_type, review_status }) =>
                    UserActionStatusAPI.put_ir_review_status({ case_id, action_type, request: review_status })
                )
            );

            return { reviewers };
        } catch (error: any) {
            return rejectWithValue(error.message || "Failed to update reviewers");
        }
    }
);
